var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentlyWorkingOn = function SvgCurrentlyWorkingOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 73 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED5321",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M11.418 27.908a16.75 16.75 0 0 1 6.846-10.668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED5321",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M37.052 45.007a16.7 16.7 0 0 1-9.144 2.713c-2.743 0-5.334-.659-7.62-1.829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED5321",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M37.546 17.24a16.75 16.75 0 0 1 6.846 10.668"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M27.908 72.104H40.1c6.096 0 6.096-9.144 0-9.144H14.192c-4.572 0-6.096 3.048-6.096 3.048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m44.672 67.532 16.764-13.716c5.06-4.603 12.454 2.097 7.62 7.62L47.72 81.248q-4.572 4.572-13.716 4.572h-21.39M12.668 49.244c5.892 0 10.668-4.776 10.668-10.668S18.56 27.908 12.668 27.908 2 32.684 2 38.576s4.776 10.668 10.668 10.668M44.672 49.244c5.892 0 10.668-4.776 10.668-10.668s-4.776-10.668-10.668-10.668-10.668 4.776-10.668 10.668 4.776 10.668 10.668 10.668M27.908 23.336c5.892 0 10.668-4.776 10.668-10.668S33.8 2 27.908 2 17.24 6.776 17.24 12.668s4.776 10.668 10.668 10.668"
  })));
};
export default SvgCurrentlyWorkingOn;